<div style="padding: 16px;">
  <cs-label style="display: block; margin-bottom: 12px;">Primary Header (root page):</cs-label>
  <div style="border: 1px solid #42464B; border-radius: 8px; overflow: hidden; margin-bottom: 24px;">
    <cs-header>
      <cs-header-title>Today</cs-header-title>
      <cs-button header-right secondary small [label]="'Today' | untranslated"></cs-button>
      <cs-icon-button header-right icon="ellipsis-vertical"></cs-icon-button>
    </cs-header>
  </div>

  <cs-label style="display: block; margin-bottom: 12px;">Secondary Header (with back button):</cs-label>
  <div style="border: 1px solid #42464B; border-radius: 8px; overflow: hidden; margin-bottom: 24px;">
    <cs-header [backButton]="true">
      <cs-header-title>Workout Details</cs-header-title>
      <cs-button header-right primary small [label]="'Save' | untranslated"></cs-button>
      <cs-icon-button header-right icon="ellipsis-vertical"></cs-icon-button>
    </cs-header>
  </div>

  <cs-label style="display: block; margin-bottom: 12px;">Header with dropdown (primary):</cs-label>
  <div style="border: 1px solid #42464B; border-radius: 8px; overflow: hidden;">
    <cs-header>
      <cs-header-title>Today</cs-header-title>
      <cs-icon header-right name="keyboard_arrow_down" style="margin-left: -8px; margin-right: auto;"></cs-icon>
      <cs-button header-right secondary small [label]="'Filter' | untranslated"></cs-button>
      <cs-icon-button header-right icon="ellipsis-vertical"></cs-icon-button>
    </cs-header>
  </div>
</div>
